<template>
    <CListGroupItem>
        <slot />
    </CListGroupItem>
</template>

<script setup>
import { CListGroupItem } from '@coreui/vue-pro'
</script>

<style scoped>

</style>
